
import axios from 'axios';
import { defineComponent } from 'vue';
import { mdiWeatherSunny,mdiWeatherPartlyCloudy,mdiWeatherCloudy,mdiWeatherFog,mdiWeatherPartlyRainy,mdiWeatherPartlySnowy, mdiWeatherPartlySnowyRainy,
mdiWeatherSnowyRainy, mdiWeatherPartlyLightning, mdiWeatherSnowy, mdiWeatherSnowyHeavy, mdiWeatherRainy, mdiWeatherPouring, mdiWeatherHail, mdiWeatherLightningRainy} from '@mdi/js';
import { getModule } from 'vuex-module-decorators';
import SignageState, { ISignageState, IWeatherByLocationPayload } from '../../store/modules/signage';

let signageState = {} as ISignageState;

export default defineComponent({
    name: 'WeatherThreeDayLayout' as string,
    data: ()=>({
        item: {} as any,
        locationQuery: '' as any,
        weather: {} as any,
        liveMessageHandler: null as any,
        liveRevision: 0,
        weatherIconKey: {
            1000: { icon: mdiWeatherSunny, fill: '#E2D248' },
            1003: { icon: mdiWeatherPartlyCloudy, fill: '#E2D248' },
            1006: { icon: mdiWeatherCloudy, fill: '#A7A7A7' },
            1009: { icon: mdiWeatherCloudy, fill: '#A7A7A7' },
            1030: { icon: mdiWeatherFog, fill: '#9499AB'},
            1063: { icon: mdiWeatherPartlyRainy, fill: '#989FFF' },
            1066: { icon: mdiWeatherPartlySnowy, fill: '#7CB5E6' },
            1069: { icon: mdiWeatherPartlySnowyRainy, fill: '#7C9CE6' },
            1072: { icon: mdiWeatherSnowyRainy, fill: '#7C9CE6' },
            1087: { icon: mdiWeatherPartlyLightning, fill: '#EEB156' },
            1114: { icon: mdiWeatherSnowy, fill: '#7CB5E6' },
            1117: { icon: mdiWeatherSnowyHeavy, fill: '#7CB5E6' },
            1135: { icon: mdiWeatherFog, fill: '#9499AB' },
            1147: { icon: mdiWeatherFog, fill: '#9499AB' },
            1150: { icon: mdiWeatherRainy, fill: '#989FFF' }, //patchy light drizzle
            1153: { icon: mdiWeatherRainy, fill: '#989FFF' },
            1168: { icon: mdiWeatherSnowyRainy, fill: '#7C9CE6' },
            1171: { icon: mdiWeatherSnowyRainy, fill: '#7C9CE6' },
            1180: { icon: mdiWeatherPartlyRainy, fill: '#989FFF' }, //patchy light  rain,
            1183: { icon: mdiWeatherRainy, fill: '#989FFF' }, //light rain
            1186: { icon: mdiWeatherPartlyRainy, fill: '#989FFF' }, //moderate rain at times
            1189: { icon: mdiWeatherRainy, fill: '#989FFF' }, //moderate rain
            1192: { icon: mdiWeatherPartlyRainy, fill: '#989FFF' }, //jeaby rain at time
            1195: { icon: mdiWeatherPouring, fill: '#989FFF' }, //heavy rain
            1198: { icon: mdiWeatherRainy, fill: '#989FFF' },
            1201: { icon: mdiWeatherPouring, fill: '#989FFF' },
            1204: { icon: mdiWeatherSnowyRainy, fill: '#7C9CE6' },
            1207: { icon: mdiWeatherSnowyRainy, fill: '#7C9CE6' },
            1210: { icon: mdiWeatherPartlySnowy, fill: '#7CB5E6' },
            1213: { icon: mdiWeatherSnowy, fill: '#7CB5E6' },
            1216: { icon: mdiWeatherPartlySnowy, fill: '#7CB5E6' }, //patchy moderate snow
            1219: { icon: mdiWeatherSnowy, fill: '#7CB5E6' }, //moderate snow
            1222: { icon: mdiWeatherPartlySnowy, fill: '#7CB5E6' }, //patchy heavy snow
            1225: { icon: mdiWeatherSnowyHeavy, fill: '#7CB5E6' },
            1237: { icon: mdiWeatherHail, fill: '#60D8E6' }, //ice pellets
            1240: { icon: mdiWeatherPartlyRainy, fill: '#989FFF' }, //light rain shower
            1243: { icon: mdiWeatherPartlyRainy, fill: '#989FFF' }, //moderate of heavy rain shower
            1246: { icon: mdiWeatherPartlyRainy, fill: '#989FFF' }, //torrential rain shower
            1249: { icon: mdiWeatherPartlySnowyRainy, fill: '#7C9CE6' }, //light sleet showers
            1252: { icon: mdiWeatherPartlySnowyRainy, fill: '#7C9CE6' }, //moderate/heavy sleet showers
            1255: { icon: mdiWeatherPartlySnowy, fill: '#7CB5E6' },
            1258: { icon: mdiWeatherPartlySnowy, fill: '#7CB5E6' },
            1261: { icon: mdiWeatherHail, fill: '#60D8E6' }, // ice pellet showers
            1264: { icon: mdiWeatherHail, fill: '#60D8E6' },
            1273: { icon: mdiWeatherPartlyLightning, fill: '#EEB156' }, //pathy light rain w/ thunder
            1276: { icon: mdiWeatherLightningRainy, fill: '#EEB156' },
            1279: { icon: mdiWeatherPartlySnowy, fill: '#7CB5E6' }, //patchy light snow w/ thunder
            1282: { icon: mdiWeatherSnowyHeavy, fill: '#7CB5E6' },
        } as any       
    
    }),

    methods: {
        getDayOfWeek(date: any){
            let day = new Date(date + " 00:00").getDay();
            let daysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

            return daysOfWeek[day];
        }
    },

    computed: {
        isFahrenheit(): boolean {
            if(this.item.temperatureScale == 'Fahrenheit')
            {
                return true;
            }
            return false;
        }
    },

    props: ['id', 'signature'],

    async mounted() {
        // FLOCK-6612: live-preview mode. When loaded by the editor's
        // LiveTemplatePreview iframe (id 'live'), skip the templaterequest
        // fetch and take layout data over postMessage from the parent
        // instead — same-origin only, since this route is unauthenticated
        // for the server-side renderer's benefit. The server render path
        // (real id + signature) is unchanged.
        if (this.id === 'live') {
            this.liveMessageHandler = (event: MessageEvent) => {
                if (event.origin !== window.location.origin) { return; }
                if (event.data && event.data.type === 'ditto-live-preview' && event.data.layoutData) {
                    this.item = { ...event.data.layoutData };
                    this.liveRevision++;
                }
            };
            window.addEventListener('message', this.liveMessageHandler);
            // Handshake: the parent's iframe 'load' event fires before this
            // component mounts, so a message posted then would be lost and
            // the preview would stay empty until the next edit. Announce
            // readiness so the parent knows exactly when to send data.
            if (window.parent && window.parent !== window) {
                window.parent.postMessage({ type: 'ditto-live-preview-ready' }, window.location.origin);
            }
            return;
        }

        signageState = getModule(SignageState);

        const templateResponse = await axios.get(`${ process.env.VUE_APP_API_HOST }/api/signages/${this.id}/templaterequest/${this.signature}`);
        if(templateResponse.data) {
            this.item = templateResponse.data;
            const weatherPayload = {
                location: this.item.location,
                days: '3'
            } as IWeatherByLocationPayload;
            const weatherResponse = await signageState.getWeatherByLocation(weatherPayload);
            if(weatherResponse.data) {
                    this.weather = weatherResponse.data;
                } else {
                    window.location.href = 'https://httpstat.us/400';
                }
        }
        else {
            window.location.href = 'https://httpstat.us/400';
        }
    },

    beforeUnmount() {
        if (this.liveMessageHandler) {
            window.removeEventListener('message', this.liveMessageHandler);
        }
    }
});
